/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCultureRequest
 */
export interface UserCultureRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCultureRequest
     */
    language_code: string;
}

/**
 * Check if a given object implements the UserCultureRequest interface.
 */
export function instanceOfUserCultureRequest(value: object): value is UserCultureRequest {
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function UserCultureRequestFromJSON(json: any): UserCultureRequest {
    return UserCultureRequestFromJSONTyped(json, false);
}

export function UserCultureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCultureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'language_code': json['language_code'],
    };
}

export function UserCultureRequestToJSON(json: any): UserCultureRequest {
    return UserCultureRequestToJSONTyped(json, false);
}

export function UserCultureRequestToJSONTyped(value?: UserCultureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'language_code': value['language_code'],
    };
}

